import { Facet, FacetRootStore, FacetStore } from "@globalgiving/vast-frontend-common"
import { action, observable } from "mobx"
import { reportInvalidFacet } from "~/helpers"
import { CategoryConfig, CategoryStore, InvalidFacetInfo } from "~/types"

export class Category implements CategoryStore {
  @observable accessor facets: FacetStore[] = []
  @observable accessor invalidFacet: InvalidFacetInfo | null = null
  config: CategoryConfig
  rootStore: FacetRootStore

  constructor(config: CategoryConfig, rootStore: FacetRootStore) {
    this.config = config
    this.rootStore = rootStore
    this.updateFacets(config)
  }

  @action
  update(config: CategoryConfig): void {
    this.config = config
    this.updateFacets(config)
  }

  private updateFacets(config: CategoryConfig): void {
    this.invalidFacet = null

    const facets: FacetStore[] = []

    for (const facetConfig of config.facets) {
      try {
        facets.push(new Facet(facetConfig, this.rootStore))
      } catch (error: unknown) {
        this.invalidFacet = reportInvalidFacet(facetConfig, error)
        this.facets = []
        return
      }
    }

    this.facets = facets
  }
}
